import { MyContextProvider } from "../../ra-lb-tools/components/myContext";
import { LockerList, LockerShow } from "../lockers";

const removedCustomFields = ["tower.isForTest"];

export const OrgLockersList = (props) => {
  return (
    <LockerList
      {...props}
      title="My Lockers"
      filterDefaultValues={null}
      removedCustomFields={removedCustomFields}
    />
  );
};

export const OrgLockerShow = () => {
  return (
    <MyContextProvider value={{ removedCustomFields }}>
      <LockerShow />
    </MyContextProvider>
  );
};
